module.exports = __webpack_public_path__ + "img/right-arrow.3816901e.svg";